<script lang="ts" >
    import { createEventDispatcher, onMount } from "svelte";
    import type { RequirementAction } from "../../../models/requirements";
    import { RequirementStore } from "../../../stores/requirement-store";
    import InputBox from "../../ui/InputBox.svelte";
    import OutlineButton from "../../common/outline-button.component.svelte";
    import AddIcon from "../../ui/icons/icon-add.svelte";
    import MultiSelect from 'svelte-multiselect'
    
    
    // Export
    // Var
    let label: string = "";
    let actors: string[] = [];
    let actorsSelected: string[] = [];
    let datas: string[] = [];
    let datasSelected: string[] = [];
    let distpatch = createEventDispatcher();

    // Reactive
    $: canAdd = (label.trim().length >= 5);

    // Functions
    onMount(() => {
        actors = RequirementStore.getActors();
        datas =  RequirementStore.getDatas();
    })

    const handleNew = () => {
        if(canAdd) {
            distpatch('action-add', {
                id: Date.now(),
                label: label,
                actors: actorsSelected,
                datas: datasSelected
            } as RequirementAction)
            label = "";
            actorsSelected = [];
            datasSelected = [];
        }
    }

</script>

<div>
    <div class="wrapper">
        {#if actors.length > 0 && datas.length > 0}
            <div class="item">
                Le ou les acteurs 
                    <MultiSelect bind:selected={ actorsSelected } options={actors} 
                        --sms-token-bg="lightgrey"
                        --sms-token-color="white"
                        --sms-border="1pt solid lightgray"
                        --sms-options-bg="#F0F0F0"
                    />    
            </div>
            <div class="item">
                manipulent la ou les données   
                <MultiSelect bind:selected={ datasSelected } options={datas} 
                    --sms-token-bg="lightgrey"
                    --sms-token-color="white"
                    --sms-border="1pt solid lightgray"
                    --sms-options-bg="#F0F0F0"
                />
            </div>
        {/if}
    </div> 
    Pour 
    <InputBox>
        <input type="text" bind:value={label}
        on:keydown={(e) => { 
            if(canAdd && e.key == "Enter") {
                handleNew();
            }
        }}
        />
    </InputBox>
    <div style="text-align:center; padding-top:5px">
        <OutlineButton on:click={handleNew} disabled={! canAdd } > <AddIcon /> </OutlineButton>
    </div>
</div>

<style>

    .wrapper {
        display: flex;
        flex-direction: row;
    }

    .item {
        flex: 1;
    }



    

</style>